import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl, removeHTMLTags,isNotEmpty, throwErrorEvent, getStageName, convertObjectToArray, getStageNameV2 } from '../../lib/ep.js';
import { useOwner } from '../context/context';
import Loadable from 'react-loadable';

import QuizStats, { ChartRowBar } from '../front/quiz/QuizStats';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';

import SectionTitle from '../builder/SectionTitle.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import Select from '../builder/Select.js';
import FaceOffStats from '../front/FaceOffStats.js';
import { LikeDislikeStatsGlobal } from '../front/LikeDislikeStats.js';
import { GuessScoreStats } from '../front/GuessScoreFinal.js';
import { getStageTitle } from '../../containers/Stage.js';
import { sortStages } from '../backend/StagesBuilder.js';
import { isMultiStage } from '../../data/bootstrap_stages.js';
import { getFullImage } from '../front/GuessScoreClient.js';

const InsightsElements = Loadable({
	loader:() => import('./InsightsElements'),
	loading:() => <div>Loading...</div>,
});

const WrapperQuiz = ({ stats, stages, stage_id, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const last_update = stats.updated ?? null;
	const tz = props.timezone ?? 'Europe/Madrid';
	const last_update_tz = EPGetTimezone(last_update, tz, 'LLL');
	const label_timezone = <span>{window?.visible_timezones?.[tz] ?? tz}</span>;
	return (
		<>
			<div class="title_with_filter">
				<SectionTitle
					_class={{ icon:props.icon }}
				>{props.title}</SectionTitle>

				{(stats) && (
					<div class="gui_flex_space_between gui_flexbox_auto">
						<div class="gui_flex_start" style={{ minWidth:'250px' }}>
							{(stats.total_registers > 0) && (
								<SectionSubtitle
									autotranslate={false}
								>{`${i18n("Total")} : <strong>${stats.total_registers}</strong>`}</SectionSubtitle>
							)}

							{(stages.length > 1) && (
								<Select
									value={stage_id}
									values={stages}
									_class={{ size:50 }}
									change={(k, v) => props.setStageId(v)}
								>Select stage</Select>
							)}
						</div>
					</div>
				)}

				<div class="filter gui_actions gui_flex_end">
					<div id='stats-export' />
				</div>
			</div>

			{props.children}
			
			{(stats) && (					
				<div class="gui_not_in_top_big gui_flexbox_auto gui_flex_col gui_flex_nowrap gui_flex_end gui_small_text">
					<FormattedMessage
						id="Last update: {date}"
						values={{ date:last_update_tz }}
					/>

					{label_timezone}
				</div>
			)}
		</>
	)
};

const QuizRefactor = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props.promotion;

	const [ stats, setStats ] = useState(null);
	const [ stages, setStages ] = useState({});
	const [ stage_id, setStageId ] = useState(null);
	
	const is_faceoff = ['faceoff', 'pick_favorite'].includes(props.type);
	const is_one_bracket = ['bracket_predictor'].includes(props.type);
	const is_likedislike = ['like_dislike'].includes(props.type);
	const is_guessscore = ['guess_score'].includes(props.type);
	const url = `/v24/insights/fetch_data/${promotion.id}/${(is_faceoff || is_one_bracket || is_likedislike || is_guessscore) ? props.type : `quizs`}`;

	useEffect(() => {
		$.getJSON(getRemotedbUrl(url), (response) => {
			if(response?.total_registers != undefined) {
				setStats(response);
				return;
			}
			setStats(false);
			setStages(null);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});;
	}, []);

	useEffect(() => {
		let _stages = null;
		if(stats) _stages = Object.values(stats.data).sort((a, b) => a.stage_pos - b.stage_pos).map(stage => ({
			k: stage.stage_id,
			v: stage.stage_title
		}));

		if(_stages && _stages.length > 1) {
			const unique_stages = _stages.filter((stage, index, self) => 
				index === self.findIndex((s) => s.k === stage.k)
			 );

			const arr_stages = [{ k:'', v:i18n("All") }];
			unique_stages.map((st) => {
				arr_stages.push(st);
			});
			if(unique_stages.length > 1) setStages(arr_stages);
		}
	}, [ stats ]);

	useEffect(() => {
		if(stage_id == '') setStageId(null);
	}, [ stage_id ]);
	
	if(stats == null) {
		return (
			<div>Loading...</div>
		);
	}

	const is_builder = true;

	const wrapper_props = {
		stages,
		stage_id,
		stats,
		intl:props.intl,
		setStageId,
		...props,
	};

	if(!stats && !is_faceoff && !is_likedislike && !is_guessscore && !is_one_bracket) {
		return (
			<QuizStats
				{...props}
			/>
		)
	}

	if(!stats) {
		return (
			<WrapperQuiz
				{...wrapper_props}
			>
				<p>{i18n("No data")}</p>
			</WrapperQuiz>
		)
	}

	if(is_faceoff || is_likedislike || is_guessscore || is_one_bracket) {
		const stages_from_stats = (props?.stages_from_stats ?? []);
		const ordered_stages = sortStages(stages_from_stats,promotion.stages_mosaic_sort_mode ?? null);

		const teams = promotion?.guess_score_teams ?? [];
		const findTeamById = (id) => {
			return teams.find((t) => (t.id == id));
		};

		return (
			<WrapperQuiz
				{...wrapper_props}
				stages={ordered_stages.length > 1 ? [{ k: '', v: i18n("All") }, ...ordered_stages.map((s) => ({ k: s.Stage.id, v: getStageTitle(s.Stage) }))]: []}
				
			>
				<ul class={`${(stages_from_stats.length > 1) ? `gui_not_in_top_huge ` : ``}gui_quiz_stats public_stats`}>
					{Object.keys(stats.data).map((element_id) => {
						let element = stats.data[element_id];
						if(stage_id && element.stage_id && element.stage_id != stage_id) return null;

						const stage = stages_from_stats.find((st) => (element.stage_id == st.Stage.id))?.Stage ?? {};	// stage filtrat per stage_id

						const players_faceoff = stage?.faceoff_players ?? [];
						const players_likedislike = stage?.likedislike_players ?? [];
						const teams_for_stats = [];

						if(is_one_bracket) {
							const matches = stage?.guess_score_matches ?? [];
							const num_rounds = parseInt(stage?.guess_score_num_rounds ?? '4');

							matches.map((match, m) => {
								if(m > Math.pow(2, num_rounds) / 2 - 1) return;
						
								const team_1 = findTeamById(match.id_1);
								const team_2 = findTeamById(match.id_2);
						
								teams_for_stats.push({
									...team_1,
									full_image:getFullImage(team_1, 'small'),
								});
						
								teams_for_stats.push({
									...team_2,
									full_image:getFullImage(team_2, 'small'),
								});
							});
						}

						if(is_faceoff && players_faceoff.length == 0) return null;
						if(is_likedislike && players_likedislike.length == 0) return null;
						if(is_one_bracket && teams.length == 0) return null;

						return (
							<li key={element_id} class={`gui_question_stat`} style={{ contentVisibility:'auto' }}>
								{(stages_from_stats.length > 1 || isMultiStage(promotion)) && (
									<LeveledHTMLText>
										<h3 class="question_text">
											<strong>{`${i18n("Stage")}: ${getStageNameV2(stage, i18n)}`}</strong>
										</h3>
									</LeveledHTMLText>
								)}

								{(is_faceoff) && (
									<FaceOffStats
										stage={stage}
										players={players_faceoff}
										stats={element?.answers ?? {}}
										max_items={'all'}
										display_abs_stats={stage?.faceoff_display_abs_stats ?? true}
										is_builder={false}
										intl={props.intl}
									/>
								)}

								{(is_likedislike) && (
									<LikeDislikeStatsGlobal
										stage={stage}
										players={players_likedislike}
										stats={element?.answers ?? {}}
										is_builder={false}
									/>
								)}

								{(is_guessscore) && (
									<GuessScoreStats
										stage={stage}
										stats={element?.answers?.combined ?? []}
										stats_score={element?.answers?.score ?? {}}
										promotion={{ Promotion:promotion }}
										display_legend={true}
										is_builder={false}
										is_backend={true}
										intl={props.intl}
									/>
								)}

								{(is_one_bracket) && (
									<FaceOffStats
										stage={stage}
										players={teams_for_stats}
										display_abs_stats={true}
										max_items={'all'}
										stats={element?.answers ?? {}}
										is_builder={false}
										intl={props.intl}
									/>
								)}
							</li>
					)})}
				</ul>
			</WrapperQuiz>
		)
	}

	return (
		<WrapperQuiz
			{...wrapper_props}
		>
			<ul class={`gui_quiz_stats${(is_builder) ? ' not_awesome gui_not_in_top_huge' : 'public_stats'}`}>
				{Object.keys(stats.data).map((element_id) => {
					let element = stats.data[element_id];
					if(stage_id && element.stage_id && element.stage_id != stage_id) return null;
					return (
						<li key={element_id} class="gui_question_stat" style={{ contentVisibility:'auto' }}>
							<LeveledHTMLText>
								<h3 class="question_text"><strong>{removeHTMLTags(element.title)}</strong></h3>
							</LeveledHTMLText>
							<ul>
								{Object.keys(element.answers).map((answer_id) => {
									const answer = element.answers[answer_id];
									let answer_type_icon = '';
									let display_total_percent = true;
									let answer_totals = (answer.total) ? convertObjectToArray(answer.total) : [];
									
									let display_suboptions = answer_totals.length > 0 ? true : false;
									let has_suboptions = answer.total != undefined ? true : false;
									if(has_suboptions && !display_suboptions)return null;
									const is_correct = ((answer?.correct ?? 0) > 0) ? answer.correct : false;
									
									return (
										<li key={answer_id} class="gui_answer_stat">
											<ul class="gui_stats_list">
												<li class="simple_question">
													{(display_total_percent && !display_suboptions) && (
														<span class="value">{answer.count} ({answer.pct}%)</span>
													)}
													<div class="results">
														<p class={`stat_label ${answer_type_icon}`}>
															<span class="gui_pos_rel gui_flexbox gui_flex_align_center" style={{ width:'100%' }}>
																<span class="gui_cutTextOnOverflow">
																		<strong>
																			{answer.title}
																			{(display_suboptions) ? (
																				<span class="label_extra">[{i18n("Average")} : {answer.avg}]</span>
																			) : (
																				(is_correct) && (
																					<span class="label_extra gui_force_bold greenColor">
																						[{`${is_correct} ${(is_correct > 1) ? i18n("Points") : i18n("Point")}`}]
																					</span>
																				)
																			)}
																		</strong>
																</span>
															</span>
														</p>
														{(!has_suboptions) && (
															<ChartRowBar
																key={`chart_${answer_id}`}
																tooltip={(!display_total_percent) ? `${answer.count} - ${answer.pct}%` : null}
																width={answer.pct}
																color={(is_correct) ? '#8bc34a' : null}
															/>
														) }
													</div>
												</li>
											</ul>							
											{(answer_totals.length > 0) && (
												<ul class="gui_stats_list is_row gui_suboptions gui_not_in_top_small">
													{(answer_totals.map((total, t) => {
															return (
																<li>
																	<p class={`stat_label gui_pos_rel`}>
																		<span class="gui_cutTextOnOverflow">
																			<strong>{total.key}</strong>
																			<span class="value gui_not_in_start_small">[ {total.num} / {total.percent}% ] </span>
																		</span>
																	</p>
																	<ChartRowBar
																		key={t}
																		tooltip={`${total.num} - ${total.percent}%`}
																		width={total.percent}
																	/>
																</li>
															)
														})
													)}
												</ul>
											)}

											{/*(display_suboptions && (opened_details == a_stats.id || is_builder)) && (
												<AnswerSuboptions
													suboptions={answer_totals}
													pre_visible={display_suboptions_opened}
												/>
											)*/}
										</li>
									)
								})}
							</ul>
						</li>
					)
				})}
			</ul>
		</WrapperQuiz>
	)
};

const SinglePromoInsight = ({ type, ...props }) => {
	const owner = useOwner();
	const promotion = props?.promotion ?? (owner?.promotion?.Promotion ?? false);
	const sweep = props?.sweep ?? false;
	const brand = props?.brand ?? false;
	const platform_id = props?.platform_id ?? null;
	const account_id = props?.account_id ?? null;

	const from_usage_stats = props?.usage_type ?? false;

	const [ loaded, setLoaded ] = useState(false);
	const [ data, setData ] = useState({});
	const [ updated, setUpdated ] = useState(null);

	const extra = useRef({});

	const fetchUsageStats = (type) => {
		let url_usage = `/v24`;
		if(promotion)url_usage+=`/monthly_stats_by_metric_and_promo/${account_id}/${type}/${platform_id}/${promotion.id}`;
		if(brand)url_usage+=`/monthly_stats_by_metric_and_brand/${account_id}/${type}/${brand.id}`;

		setLoaded(false);
		$.getJSON(getRemotedbUrl(url_usage), (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setData(res.data);
			setLoaded(true);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const fetchGenericInsights = (overwrite_type) => {
		setLoaded(false);
		$.getJSON(getRemotedbUrl(`/insights/fetch_generic_data/${type}/${overwrite_type}`), (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setData(res.data);
			setLoaded(true);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const fetchSweepInsights = () => {
		setLoaded(false);
		$.getJSON(getRemotedbUrl(`/insights/fetch_sweep_data/${sweep.id}/${type}`), (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setData(res.data);
			setLoaded(true);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const fetchInsightsPagination = (last, cb) => {
		setLoaded(false);

		let obj_send = { last, limit:10000 }
		if(platform_id)obj_send.platform_id = platform_id;
		$.getJSON(getRemotedbUrl(`/insights/fetch_data/${promotion.id}/${type}`), obj_send, (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setLoaded(true);
			setData((current) => {
				for(var graph_id in res.data) {
					if(current[graph_id] == undefined) {
						current[graph_id] = res.data[graph_id];
						continue;
					}

					let _found = false;
					(res.data[graph_id].data).map((item) => {
						let current_exist = (current[graph_id].data).find((c) => (c.name == item.name));
						if(current_exist) {
							_found = true;
						}
					});

					if(!_found) {
						current[graph_id].data = [ ...current[graph_id].data, ...res.data[graph_id].data ];
					}

					if(current[graph_id].data[0].name != undefined && Number.isInteger(current[graph_id].data[0].name)) {
						current[graph_id].data.sort((a,b)=>(parseInt(a.name) < parseInt(b.name) ? -1 : 1));
					}
				}
				
				return { ...current };
			});

			if(cb != undefined) cb(res);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const fetchInsights = () => {
		setLoaded(false);
		$.getJSON(getRemotedbUrl(`/insights/fetch_data/${promotion.id}/${type}`), (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setData(res.data);
			setLoaded(true);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const dataInsightsLaravel = (_type) => {
		setLoaded(false);
		$.getJSON(getRemotedbUrl(`/v24/insights/fetch_data/${promotion.id}/${_type}`), (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setData(res.data);
			setLoaded(true);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const fetchPromotionEmailsInsights = (email_id) => {
		setLoaded(false);
		$.getJSON(getRemotedbUrl(`/v24/emails/statistics/${promotion.id}/${email_id}`), (res) => {
			extra.current = {...res};
			delete extra.current.data;
			if(res.updated) setUpdated(res.updated);
			setData(res.data);
			setLoaded(true);
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	useEffect(() => {
		const callback = (res) => {
			if(res.hasMore) {
				fetchInsightsPagination(res.last, callback);
			}
		}
		if(from_usage_stats){
			fetchUsageStats(type);
		}else{
			switch(type) {
				case 'quiz':
				case 'faceoff':
				case 'pick_favorite':
				case 'like_dislike':
				case 'guess_score':
				case 'bracket_predictor':
					break;
				case 'participants':
				case 'participations':
				case 'pageviews':
				case 'shares':
				case 'networks':
				case 'sources':
				case 'prizes':
				case 'coins':
				case 'prize_redemption':
				case 'game':
				case 'qr_scans':
				case 'votes':
				case 'prizes_download':
					dataInsightsLaravel(type);
					break;

				case 'visits':
				//case 'sources':
				//case 'game':
					fetchInsights();
					break;

				case 'sweep':
					fetchSweepInsights();
					break;

				case 'qos':
				case 'promo_type_stats':
					fetchGenericInsights();
					break;

				case 'account_participation_stats':
				case 'account_email_stats':
					const account_id = props?.account_id ?? null;
					fetchGenericInsights(`${type}-${account_id}`);
					break;

				case 'promotion_emails':
					const email_id = props?.email_id ?? null;
					fetchPromotionEmailsInsights(email_id);
					break;

				default:
					fetchInsightsPagination(false, (res) => {
						callback(res);
					});
					break;
			}
		}
	}, []);

	let allowed = false;
	if(['qos','promo_type_stats','account_participation_stats','account_email_stats'].includes(type)) allowed = true;

	if(promotion === false && sweep === false && brand === false && !allowed) return null;

	const total_registers = extra?.current?.total_registers ?? 0;
	const total_unique_registers = extra?.current?.total_uniques ?? 0;
	if(['quiz', 'faceoff', 'pick_favorite', 'like_dislike', 'guess_score', 'bracket_predictor'].includes(type)) {
		return (
			<QuizRefactor
				promotion={promotion}
				icon={props?.active?.icon ?? 'knk-quiz'}
				title = {props?.active?.title ?? "Quiz"}
				active={props.active}
				intl={props.intl}
				timezone={promotion?.timezone ?? 'Europe/Madrid'}
				type={type}
				stages_from_stats={props?.stages ?? []}
			/>
		)
	}

	return (
		<InsightsElements
			updated={updated}
			graphs={data}
			loaded={loaded}
			extra={(total_registers > 0) ? { total_registers, total_unique_registers } : null}
			active={props.active}
			promotion={promotion ? promotion : sweep}
			sweep={sweep}
			no_data_message = {props?.no_data_message ?? null}
			intl={props.intl}
		/>
	)
};

export default SinglePromoInsight;